import { useTheme } from '@mui/material';
import type { ComponentType } from 'react';

import type { IconProps } from '../../../icons';
import { OtherResourceIcon } from '../../../icons';
import {
  type ResourceColorName,
  type ResourceColorPalette,
  resourcesColors,
} from '../../../theme/tokens/resourcesColors';
import { resourcesIcons } from '../../../theme/tokens/resourcesIcons';

export type ResourceTimelineSeparatorVariant = ResourceColorName;

export type ResourceTimelineSeparatorMeta = {
  icon: ComponentType<IconProps>;
  color: string;
  bgColor: string;
  textColor: string;
};

export type ResourceTimelineSeparatorProps = {
  variant: ResourceTimelineSeparatorVariant;
  'data-testid'?: string;
};

export function useResourceTimelineSeparator(props: ResourceTimelineSeparatorProps) {
  const theme = useTheme();

  const paletteColor =
    theme.palette[props.variant] ??
    theme.palette.resourcesColors?.[props.variant] ??
    resourcesColors[props.variant];

  const resourceColor: ResourceColorPalette = {
    main: paletteColor?.main ?? resourcesColors[props.variant]?.main ?? '#616161',
    light: paletteColor?.light ?? resourcesColors[props.variant]?.light ?? '#f5f5f5',
    dark: paletteColor?.dark ?? resourcesColors[props.variant]?.dark ?? '#212121',
    contrastText: paletteColor?.contrastText ?? resourcesColors[props.variant]?.contrastText ?? '#ffffff',
  };

  const IconComponent =
    theme.resourceIcons?.[props.variant] ??
    resourcesIcons[props.variant] ??
    OtherResourceIcon;

  const meta: ResourceTimelineSeparatorMeta = {
    icon: IconComponent,
    color: resourceColor.main,
    bgColor: resourceColor.light,
    textColor: resourceColor.main,
  };

  return {
    meta,
    IconComponent,
  };
}
